import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { buttonColors, buttonTextColors } from '@/components/ui/Button/Button';
import { LinkButtonBase } from '@/components/ui/Button/LinkButtonBase';
/**
 * ボタンデザインが必要ない場合：
 * color={'none'}
 * isBordered={false}
 * size={'fluid'}
 */
/**
 * 共通：ボタンコンポーネント
 * @param props
 * @constructor
 */
export const LinkButton = (props) => {
    const { children, className = '', color, disabled, externalLinkAttributes, isBordered, isFull, isFullRounded, onClick, routerLinkAttributes, size, target, textClassName, to, } = props;
    const shadow = 'drop-shadow-sm active:drop-shadow-none';
    return (_jsx(LinkButtonBase, Object.assign({ className: clsx(buttonColors[color].bg, buttonColors[color].border, shadow, className), disabled: disabled, externalLinkAttributes: externalLinkAttributes, isBordered: isBordered, isFull: isFull, isFullRounded: isFullRounded, onClick: onClick, routerLinkAttributes: routerLinkAttributes, size: size, target: target, textClassName: textClassName, textColor: buttonTextColors[color], to: to }, { children: children })));
};
